module.exports = __webpack_public_path__ + "static/media/gcodes.c57f1365.jpg";